import ThreeInstance from 'src/sdk-components/ThreeInstance';
export const iTHREE = async () => {
  return ThreeInstance.get();
};
export default iTHREE;
